import { Injectable } from '@angular/core';
import { AResourceService } from './a-resource.service';
import {RouteModel} from "../../models/resources/route.model";

@Injectable({
  providedIn: 'root',
})
export class RouteService extends AResourceService<RouteModel> {

  constructor() {
    super('/optimization-runs', true, [
      // 'optimizationRunStops',
      'configurationProfile'
    ]);
  }
}
